
export function isOneOrMore(value: string | number | undefined | boolean | string[] ): boolean {
  const num = Number(value);
  return typeof value !== 'undefined' && !isNaN(num) && num >= 1;
}